module.exports = __webpack_public_path__ + "img/Feature.8fe7f24d.png";